import {FunctionComponent, SelectHTMLAttributes} from 'react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';
import {useFormControlContext} from '../form-control/form-control';

type ElementProps = SelectHTMLAttributes<HTMLSelectElement> & {
  isReadonly?: boolean;
};

const Select: FunctionComponent<ElementProps> = ({children, isReadonly = false, ...props}) => {
  const {isDisabled, isInError, hasWarning} = useFormControlContext();

  const mergedClasses = clsx(
    'w-full cursor-pointer appearance-none overflow-hidden rounded-1 border border-violet bg-select-arrow bg-no-repeat p-4 pr-8 text-base text-violet placeholder-violet outline-none transition-all',
    'hover:shadow-input focus:border-violet focus:text-violet focus:placeholder-charcoal focus:shadow-inputFocus',
    props.className,
    isDisabled && 'cursor-not-allowed bg-gray-200',
    isInError &&
      'border-red text-red placeholder-red caret-red hover:text-red hover:shadow-inputError focus:border-red focus:text-red focus:shadow-inputError',
    hasWarning &&
      'border-yellow-600 text-yellow-600 placeholder-yellow-600 caret-yellow-600 hover:text-yellow-600 hover:shadow-inputError focus:border-yellow-600 focus:text-yellow-600 focus:shadow-inputError',
    isReadonly &&
      'cursor-not-allowed border-grey-650 bg-select-arrow-readonly text-grey-650 placeholder-grey-650 shadow shadow-grey-400 hover:shadow-grey-400 focus:border-grey-400 focus:text-grey-650 focus:placeholder-grey-650',
  );

  return (
    <select disabled={isDisabled || isReadonly} {...props} className={twMerge(mergedClasses)}>
      {children}
    </select>
  );
};

export default Select;
